import React from 'react';
import ClosedCard from '../../shared/components/ClosedCard';
import '../../line/styles/line.css'; // 既存のCSSを流用（必要なら queue.css にリネーム可）

try { window.__LINE_DBG_PUSH?.({ tag: 'PublicQueueList:loaded' }); } catch {}

export default function PublicQueueList({
   inhouseOn,
   waitCount,
   nowStr,
   list = [],                 
   myAheadCount,
   showMineBadge = false,
}){


  if (inhouseOn === false) {
    return (
      <div className="line-container">
        <ClosedCard
          title="現在、院内受付は停止中です"
          description="院内でも診察の順番受付を承っています。受付をご希望の方はスタッフまでお声がけください。"
        />
      </div>
    );
  }

  const showMyAhead = myAheadCount != null && Number.isFinite(myAheadCount);

  return (
    <div className="line-container">
      <div className="line-card line-all">
        {/* カウンタ */}
        <div className="line-all-head">
          <div className="line-all-count">
            {waitCount == null
              ? '—'
              : showMyAhead
                  ? `${myAheadCount} / ${waitCount}`
                  : `${waitCount}`
            }
          </div>
          <div className="line-all-count-label">
            {showMyAhead ? 'あなたまであと / 全体の待ち人数' : '人の方がお待ちです'}
          </div>
        </div>
        <div className="line-all-time">{nowStr}</div>

        {/* 一覧 */}
        <div className="line-all-table">
          <div className="line-all-row line-all-row--head">
            <div className="line-all-cell line-all-cell--head">受付番号</div>
            <div className="line-all-cell line-all-cell--head">あと</div>
          </div>

          {(list ?? []).map(r => {
            const rowCls = `line-all-row${r.isMine ? ' line-all-row--mine' : ''}`;
            return (
              <div key={r.id} className={rowCls}>
                <div className="line-all-cell line-all-cell--no">
                  <div className="line-all-no">{r.no}</div>
                  {r.isHold && <div className="line-all-hold">呼出時不在（保留中）</div>}
                </div>
                <div className="line-all-cell line-all-cell--ahead">
                  {r.isHold ? (
                    <div className="line-all-ahead-hold">-</div>
                  ) : r.isMine ? (
                    // 自分の予約時は人数表示の代わりに「あなた」
                    <div className="line-all-ahead line-all-ahead--mine">あなた</div>
                  ) : (
                    <div className="line-all-ahead">{r.ahead}人</div>
                  )}
                </div>
              </div>
            );
          })}

          <div className="line-all-footer">
            診察開始30分後からオンラインでご予約いただけます
          </div>
        </div>
      </div>
    </div>
  );
}
